import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import { FaHeart, FaShoppingCart } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function PostDetail() {
  const { id } = useParams();
  const [notification, setNotification] = useState('');

  const posts = {
    '1': {
      title: 'Η Σημασία της Μουσικής Εκπαίδευσης για Παιδιά',
      date: '15 Ιανουαρίου 2025',
      author: 'Μαρία Παπαδοπούλου',
      image: '/images/1.jpg',
      content: `
        <p>Η μουσική εκπαίδευση αποτελεί ένα από τα πιο σημαντικά εργαλεία για την ολοκληρωμένη ανάπτυξη των παιδιών. Δεν πρόκειται απλώς για την εκμάθηση ενός μουσικού οργάνου ή την ικανότητα να τραγουδούν σωστά. Η μουσική εκπαίδευση επηρεάζει βαθιά τον τρόπο που τα παιδιά σκέφτονται, αισθάνονται και αλληλεπιδρούν με τον κόσμο γύρω τους.</p>

        <p>Έρευνες έχουν δείξει ότι τα παιδιά που ασχολούνται με τη μουσική από μικρή ηλικία αναπτύσσουν ισχυρότερες γνωστικές δεξιότητες. Η εκμάθηση μουσικής ενεργοποιεί πολλαπλές περιοχές του εγκεφάλου ταυτόχρονα, συμπεριλαμβανομένων αυτών που σχετίζονται με τη μνήμη, την προσοχή, τη γλώσσα και τις μαθηματικές ικανότητες. Αυτή η πολύπλευρη διέγερση του εγκεφάλου βοηθά στη δημιουργία νέων νευρικών συνδέσεων που ενισχύουν τη συνολική γνωστική λειτουργία.</p>

        <p>Επιπλέον, η μουσική εκπαίδευση καλλιεργεί την πειθαρχία και την υπομονή. Η εκμάθηση ενός μουσικού οργάνου απαιτεί τακτική εξάσκηση, επιμονή και αφοσίωση. Τα παιδιά μαθαίνουν να θέτουν στόχους, να εργάζονται συστηματικά για την επίτευξή τους και να ανταμείβονται για την προσπάθειά τους. Αυτές οι δεξιότητες είναι μεταφέρσιμες σε όλες τις πτυχές της ζωής τους.</p>

        <p>Η συναισθηματική ανάπτυξη είναι άλλη μια σημαντική πτυχή της μουσικής εκπαίδευσης. Η μουσική προσφέρει στα παιδιά έναν τρόπο να εκφράσουν τα συναισθήματά τους με υγιή και δημιουργικό τρόπο. Μέσα από τη μουσική, μπορούν να εξερευνήσουν και να επεξεργαστούν πολύπλοκα συναισθήματα, αναπτύσσοντας συναισθηματική νοημοσύνη και ωριμότητα.</p>

        <p>Τέλος, η μουσική εκπαίδευση προωθεί την κοινωνική αλληλεπίδραση και τη συνεργασία. Είτε παίζουν σε μια ορχήστρα είτε τραγουδούν σε μια χορωδία, τα παιδιά μαθαίνουν να εργάζονται ως μέλη μιας ομάδας, να ακούν τους άλλους και να συντονίζουν τις προσπάθειές τους για να πετύχουν ένα κοινό στόχο. Αυτές οι εμπειρίες οικοδομούν ισχυρές κοινωνικές δεξιότητες που θα τους χρησιμεύσουν σε όλη τους τη ζωή.</p>
      `
    },
    '2': {
      title: 'Πώς να Επιλέξετε το Κατάλληλο Μουσικό Όργανο',
      date: '12 Ιανουαρίου 2025',
      author: 'Γιώργος Κωνσταντίνου',
      image: '/images/2.jpg',
      content: `
        <p>Η επιλογή του κατάλληλου μουσικού οργάνου είναι μια σημαντική απόφαση που μπορεί να επηρεάσει σημαντικά το μουσικό ταξίδι ενός ατόμου. Δεν υπάρχει ένα τέλειο όργανο για όλους, καθώς η επιλογή εξαρτάται από πολλούς παράγοντες, συμπεριλαμβανομένης της ηλικίας, των προσωπικών προτιμήσεων, των φυσικών δυνατοτήτων και των μουσικών στόχων.</p>

        <p>Για παιδιά μικρής ηλικίας, το πιάνο ή η κιθάρα είναι συχνά εξαιρετικές επιλογές για να ξεκινήσουν. Το πιάνο προσφέρει μια άμεση οπτική αναπαράσταση της μουσικής θεωρίας και είναι σχετικά εύκολο να παράγει έναν ευχάριστο ήχο από την αρχή. Η κιθάρα, από την άλλη πλευρά, είναι πιο φορητή και ιδιαίτερα δημοφιλής σε νέους μουσικούς που ενδιαφέρονται για σύγχρονα μουσικά είδη.</p>

        <p>Τα έγχορδα όργανα όπως το βιολί, η βιόλα και το τσέλο απαιτούν μεγαλύτερη υπομονή και αφοσίωση στην αρχή, καθώς η παραγωγή ενός καλού ήχου μπορεί να πάρει χρόνο. Ωστόσο, προσφέρουν μια βαθιά συναισθηματική εκφραστικότητα και είναι απαραίτητα για όσους ενδιαφέρονται για κλασική μουσική ή μουσική δωματίου.</p>

        <p>Τα πνευστά όργανα, όπως η φλογέρα, το κλαρινέτο και το σαξόφωνο, είναι εξαιρετικές επιλογές για όσους απολαμβάνουν να παίζουν σε ορχήστρες ή μπάντες. Απαιτούν ανάπτυξη ειδικών τεχνικών αναπνοής και στόματος, αλλά μπορούν να είναι εξαιρετικά ικανοποιητικά όταν κατακτηθούν.</p>

        <p>Τα κρουστά όργανα είναι ιδανικά για όσους έχουν φυσική αίσθηση ρυθμού και απολαμβάνουν την κίνηση και την ενέργεια. Τα τύμπανα και άλλα κρουστά προσφέρουν μια μοναδική μουσική εμπειρία και είναι κεντρικά στην πλειονότητα των μουσικών συγκροτημάτων.</p>

        <p>Τελικά, η καλύτερη επιλογή είναι το όργανο που σας εμπνέει και σας κάνει να θέλετε να εξασκείστε. Συνιστάται να δοκιμάσετε διαφορετικά όργανα πριν πάρετε την τελική σας απόφαση και να συμβουλευτείτε έναν έμπειρο μουσικό παιδαγωγό που μπορεί να σας καθοδηγήσει με βάση τις ατομικές σας ανάγκες και δυνατότητες.</p>
      `
    },
    '3': {
      title: 'Τεχνικές Πιάνου για Αρχάριους',
      date: '10 Ιανουαρίου 2025',
      author: 'Ελένη Νικολάου',
      image: '/images/3.jpg',
      content: `
        <p>Η εκμάθηση του πιάνου είναι ένα συναρπαστικό ταξίδι που απαιτεί υπομονή, αφοσίωση και σωστή τεχνική από την αρχή. Οι πρώτες εβδομάδες και μήνες είναι κρίσιμοι για τη δημιουργία των θεμελίων πάνω στα οποία θα χτιστούν όλες οι μελλοντικές δεξιότητες.</p>

        <p>Η σωστή στάση του σώματος είναι το πρώτο και πιο σημαντικό βήμα. Καθίστε σε μέτριο ύψος στο σκαμνί, με τα πόδια σταθερά στο πάτωμα και την πλάτη ίσια αλλά όχι άκαμπτη. Οι ώμοι πρέπει να είναι χαλαροί και οι αγκώνες σε ελαφρώς υψηλότερο επίπεδο από τα πλήκτρα. Αυτή η στάση επιτρέπει τη μέγιστη ελευθερία κίνησης και αποφεύγει την κόπωση και τον πόνο.</p>

        <p>Η θέση των χεριών είναι εξίσου σημαντική. Φανταστείτε ότι κρατάτε απαλά μια μπάλα στην παλάμη σας, με τα δάχτυλα ελαφρώς κυρτωμένα. Τα νύχια πρέπει να είναι κοντά και η επαφή με τα πλήκτρα να γίνεται με τις μαξιλαρίτσες των δαχτύλων. Ο καρπός πρέπει να παραμένει σε ευθυγράμμιση με το μπράτσο, ούτε πολύ ψηλά ούτε πολύ χαμηλά.</p>

        <p>Οι πρώτες ασκήσεις πρέπει να επικεντρώνονται στην ανεξαρτησία των δαχτύλων. Κάθε δάχτυλο έχει διαφορετική φυσική δύναμη και ευκινησία, και είναι σημαντικό να αναπτύξετε την ικανότητα κάθε δαχτύλου να κινείται ανεξάρτητα με ελεγχόμενη δύναμη. Απλές ασκήσεις κλιμάκων και αρπεζίων είναι ιδανικές για αυτό.</p>

        <p>Η ανάγνωση μουσικής είναι μια δεξιότητα που πρέπει να αναπτύσσεται παράλληλα με την τεχνική. Ξεκινήστε με απλές μελωδίες σε μία χειρά και σταδιακά προχωρήστε σε πιο σύνθετες παρτιτούρες. Εξασκηθείτε στην αναγνώριση των νοτών τόσο στην κλειδαρία του σολ όσο και στην κλειδαρία του φα, και μάθετε να διαβάζετε πολλαπλές νότες ταυτόχρονα.</p>

        <p>Τέλος, η καθημερινή εξάσκηση είναι το κλειδί για την πρόοδο. Ακόμα και 15-20 λεπτά εστιασμένης εξάσκησης κάθε μέρα είναι πιο αποτελεσματικά από μακρύτερες αλλά λιγότερο συχνές συνεδρίες. Θυμηθείτε ότι η ποιότητα είναι πιο σημαντική από την ποσότητα, και ότι η υπομονή και η επιμονή θα σας οδηγήσουν στην επιτυχία.</p>
      `
    },
    '4': {
      title: 'Η Ιστορία της Κλασικής Μουσικής στην Ελλάδα',
      date: '8 Ιανουαρίου 2025',
      author: 'Δημήτρης Αλεξίου',
      image: '/images/4.jpg',
      content: `
        <p>Η κλασική μουσική στην Ελλάδα έχει μια πλούσια και συναρπαστική ιστορία που εκτείνεται από τους αρχαίους χρόνους μέχρι σήμερα. Η μουσική ήταν πάντα κεντρικό στοιχείο του ελληνικού πολιτισμού, αναπόσπαστα συνδεδεμένη με τη φιλοσοφία, τη λογοτεχνία και τις τέχνες.</p>

        <p>Στην αρχαία Ελλάδα, η μουσική θεωρούνταν θεία τέχνη. Οι αρχαίοι φιλόσοφοι όπως ο Πλάτων και ο Αριστοτέλης έγραψαν εκτενώς για τη δύναμη της μουσικής να διαμορφώνει το χαρακτήρα και να επηρεάζει την ηθική. Η μουσική ήταν αναπόσπαστο μέρος των θεατρικών παραστάσεων, των θρησκευτικών τελετών και των αθλητικών αγώνων.</p>

        <p>Κατά τη βυζαντινή περίοδο, η ελληνική μουσική παράδοση συνεχίστηκε μέσα από την εκκλησιαστική μουσική. Η βυζαντινή μουσική ανέπτυξε ένα πολύπλοκο σύστημα τροπαρίων και υμνολογίας που επηρέασε σημαντικά την ανάπτυξη της ευρωπαϊκής μουσικής. Πολλοί από τους βυζαντινούς ρυθμούς και μελωδικούς τύπους παραμένουν ζωντανοί στη σύγχρονη ελληνική μουσική.</p>

        <p>Η σύγχρονη κλασική μουσική στην Ελλάδα ξεκίνησε να αναπτύσσεται τον 19ο αιώνα, μετά την ανεξαρτησία της χώρας. Έλληνες συνθέτες όπως ο Νικόλαος Μάντζαρος, που έγραψε την εθνική μουσική του ελληνικού εθνικού ύμνου, και αργότερα ο Μανώλης Καλομοίρης, ο Νίκος Σκαλκώτας και ο Δημήτρης Μητρόπουλος, έφεραν τη διεθνή αναγνώριση στην ελληνική κλασική μουσική.</p>

        <p>Σήμερα, η Ελλάδα διαθέτει μια ζωντανή σκηνή κλασικής μουσικής με αξιόλογες ορχήστρες, όπως η Κρατική Ορχήστρα Αθηνών, και σημαντικούς χώρους παραστάσεων όπως το Μέγαρο Μουσικής Αθηνών. Νέοι Έλληνες συνθέτες και ερμηνευτές συνεχίζουν να συνεισφέρουν στην παγκόσμια μουσική σκηνή, συνδυάζοντας τη βαθιά μουσική παράδοση της χώρας με σύγχρονες επιρροές.</p>

        <p>Η μουσική εκπαίδευση παίζει κεντρικό ρόλο στη διατήρηση αυτής της πλούσιας κληρονομιάς. Τα ωδεία και οι μουσικές σχολές σε όλη την Ελλάδα εξακολουθούν να διδάσκουν τόσο την κλασική ευρωπαϊκή όσο και την ελληνική μουσική παράδοση, εξασφαλίζοντας ότι οι νέες γενιές θα συνεχίσουν να εκτιμούν και να αναπτύσσουν αυτή την πολιτιστική κληρονομιά.</p>
      `
    },
    '5': {
      title: 'Οφέλη της Μουσικής Θεραπείας',
      date: '5 Ιανουαρίου 2025',
      author: 'Σοφία Μητροπούλου',
      image: '/images/5.jpg',
      content: `
        <p>Η μουσική θεραπεία είναι μια επιστημονικά τεκμηριωμένη θεραπευτική προσέγγιση που χρησιμοποιεί τη μουσική για να αντιμετωπίσει φυσικές, ψυχολογικές, γνωστικές και κοινωνικές ανάγκες. Δεν πρόκειται απλώς για την ακρόαση μουσικής, αλλά για μια δομημένη διαδικασία που καθοδηγείται από εκπαιδευμένους μουσικοθεραπευτές.</p>

        <p>Ένα από τα πιο σημαντικά οφέλη της μουσικής θεραπείας είναι η μείωση του άγχους και του στρες. Έρευνες έχουν δείξει ότι η μουσική μπορεί να μειώσει τα επίπεδα του κορτιζόλης, της ορμόνης του στρες, στο σώμα. Η ακρόαση ή η δημιουργία μουσικής ενεργοποιεί το σύστημα επιβράβευσης του εγκεφάλου, απελευθερώνοντας ντοπαμίνη και δημιουργώντας αισθήματα ευχαρίστησης και χαλάρωσης.</p>

        <p>Για άτομα με νευρολογικές παθήσεις όπως το εγκεφαλικό επεισόδιο ή η νόσος του Πάρκινσον, η μουσική θεραπεία μπορεί να βοηθήσει στην ανάκτηση της κινητικότητας και της ομιλίας. Ο ρυθμός της μουσικής μπορεί να βοηθήσει στην οργάνωση των κινήσεων, ενώ η μελωδία μπορεί να διευκολύνει την ανάκληση λέξεων και φράσεων.</p>

        <p>Στη γνωστική λειτουργία, η μουσική θεραπεία έχει δείξει εντυπωσιακά αποτελέσματα. Για άτομα με άνοια ή νόσο Alzheimer, η μουσική μπορεί να ενεργοποιήσει μνήμες που φαίνονται χαμένες και να βελτιώσει την ποιότητα ζωής. Τραγούδια από το παρελθόν μπορούν να ενεργοποιήσουν συναισθηματικές μνήμες και να βοηθήσουν στην επικοινωνία.</p>

        <p>Στον τομέα της ψυχικής υγείας, η μουσική θεραπεία χρησιμοποιείται για την αντιμετώπιση της κατάθλιψης, του άγχους και του τραύματος. Η δημιουργία μουσικής προσφέρει έναν ασφαλή τρόπο έκφρασης συναισθημάτων που μπορεί να είναι δύσκολο να εκφραστούν με λόγια. Η διαδικασία της μουσικής δημιουργίας μπορεί να ενδυναμώσει και να βοηθήσει τα άτομα να ανακτήσουν την αίσθηση του ελέγχου στη ζωή τους.</p>

        <p>Τέλος, η μουσική θεραπεία είναι εξαιρετικά αποτελεσματική για παιδιά με αναπτυξιακές διαταραχές όπως ο αυτισμός. Η μουσική μπορεί να βοηθήσει στην ανάπτυξη κοινωνικών δεξιοτήτων, στη βελτίωση της επικοινωνίας και στη ρύθμιση των συναισθημάτων. Οι δομημένες μουσικές δραστηριότητες παρέχουν ένα προβλέψιμο και ασφαλές περιβάλλον όπου τα παιδιά μπορούν να εξερευνήσουν και να αναπτύξουν νέες δεξιότητες.</p>
      `
    }
  };

  const post = posts[id];

  if (!post) {
    return (
      <div className="post-detail">
        <h1>Το άρθρο δεν βρέθηκε</h1>
        <Link to="/" className="btn btn-primary">Επιστροφή στην Αρχική</Link>
      </div>
    );
  }

  const handleFavorite = () => {
    setNotification('Το άρθρο προστέθηκε στα αγαπημένα σας!');
    setTimeout(() => setNotification(''), 3000);
  };

  const handleShare = () => {
    setNotification('Η λειτουργία κοινοποίησης θα είναι σύντομα διαθέσιμη!');
    setTimeout(() => setNotification(''), 3000);
  };

  return (
    <>
      <Helmet>
        <title>Halecor - Μουσική Σχολή</title>
        <meta name="description" content="Halecor - Μουσική Σχολή - Ανακαλύψτε τον κόσμο της μουσικής με επαγγελματικούς εκπαιδευτές και σύγχρονες μεθόδους διδασκαλίας" />
      </Helmet>

      <div className="post-detail">
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": post.title,
          "image": `https://halecor.com${post.image}`,
          "datePublished": post.date,
          "author": {
            "@type": "Person",
            "name": post.author
          },
          "publisher": {
            "@type": "Organization",
            "name": "Halecor",
            "logo": {
              "@type": "ImageObject",
              "url": "https://halecor.com/images/logo.jpg"
            }
          }
        })}
      </script>

      <div className="post-detail-header">
        <h1 className="post-detail-title">{post.title}</h1>
        <div className="post-meta">
          <span>{post.date}</span>
          <span>{post.author}</span>
        </div>
      </div>

      <img src={post.image} alt={post.title} className="post-detail-image" />

      <div className="post-detail-content" dangerouslySetInnerHTML={{ __html: post.content }} />

      <div className="post-actions">
        <button onClick={handleFavorite} className="btn btn-secondary">
          <FaHeart /> Προσθήκη στα Αγαπημένα
        </button>
        <button onClick={handleShare} className="btn btn-outline">
          <FaShoppingCart /> Κοινοποίηση
        </button>
        <Link to="/" className="btn btn-primary">
          Επιστροφή στην Αρχική
        </Link>
      </div>

      {notification && (
        <div className="notification">
          {notification}
        </div>
      )}
    </div>
  
    </>);
}

export default PostDetail;